var CloseCircleFill = {
  name: 'close-circle',
  theme: 'fill',
  icon: {
    tag: 'svg',
    attrs: { viewBox: '0 0 16 16', focusable: false },
    children: [
      {
        tag: 'g',
        attrs: {
          'clip-path': 'url(#clip0_516_5907)',
        },
        children: [
          {
            tag: 'path',
            attrs: {
              d: 'M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z',
              fill: '#757575',
            },
          },
          {
            tag: 'path',
            attrs: {
              'fill-rule': 'evenodd',
              'clip-rule': 'evenodd',
              d: 'M4.76654 5.96862C4.43459 5.63668 4.43459 5.09849 4.76653 4.76654C5.09848 4.43459 5.63667 4.43459 5.96862 4.76653L7.99986 6.79775L10.0311 4.76653C10.363 4.43459 10.9012 4.43459 11.2332 4.76654C11.5651 5.09849 11.5651 5.63668 11.2332 5.96862L9.20195 7.99983L11.2331 10.0309C11.565 10.3629 11.565 10.9011 11.2331 11.233C10.9011 11.565 10.3629 11.565 10.031 11.233L7.99986 9.2019L5.96872 11.233C5.63677 11.565 5.09858 11.565 4.76664 11.233C4.43469 10.9011 4.4347 10.3629 4.76664 10.0309L6.79777 7.99983L4.76654 5.96862Z',
              fill: 'white',
            },
          },
        ],
      },
      {
        tag: 'defs',
        children: [
          {
            tag: 'clipPath',
            attrs: {
              id: 'clip0_516_5907',
            },
            children: [
              {
                tag: 'rect',
                attrs: {
                  width: '16',
                  height: '16',
                  fill: 'white',
                },
              },
            ],
          },
        ],
      },
    ],
  },
}
export default CloseCircleFill
